import { getFintoc } from '@fintoc/fintoc-js'
import { BankAPI } from '../../../../../../../api/bancos.api'
import { useBanks } from '../useBanks.hook'

const bankAPI = new BankAPI()
let widgetInstance = null
let fintocPromise = getFintoc() // Pre-load the library as soon as the module is imported

export const sendExchangeTokenToBackend = async (exchangeToken, businessId) => {
  try {
    const response = await bankAPI.sendExchangeTokenToBackend(exchangeToken, businessId)
    console.log('response sendExchangeTokenToBackend', response)

    const accounts = response?.data?.accounts || []
    const linkToken = response?.data?.link_token

    console.log(accounts)
    console.log(linkToken)

    // Bridge: solo si hay cuentas nuevas Y no se ha mostrado antes para este negocio
    const flagKey = `bank_bridge_done:${businessId}`
    const alreadyDone = typeof window !== 'undefined' && localStorage.getItem(flagKey) === '1'
    const isFirstFromAccounts =
      Array.isArray(accounts) && accounts.some(a => a?.isNewAccount || a?.isNew || a?.firstTime) // fallback defensivo
    const shouldShowBridge = isFirstFromAccounts && !alreadyDone
    const banksStore = useBanks.getState()
    if (shouldShowBridge) {
      banksStore.startBankBridge(true) // state: 'starting'
    }
    console.log('[BRIDGE]', {
      accountsLen: accounts?.length ?? 0,
      isFirstFromAccounts,
      alreadyDone,
      shouldShowBridge
    })

    // Llamadas en secuencia con progreso
    const total = accounts.length || 1
    for (let i = 0; i < accounts.length; i++) {
      const account = accounts[i]
      const accountId = account.id
      const idIsNew = account.isNewAccount
      const accountIdSql = account.accountIdSql

      if (shouldShowBridge) {
        banksStore.updateBankBridge({
          state: 'running',
          phase: i,
          progress: i / total
        })
      }

      console.log(
        `Procesando cuenta con ID: ${accountId} , accountIdSql: ${accountIdSql} y idIsNew ${idIsNew}`
      )
      // const path = `/v1/business/bank/${id}/${idSql}/movements-single?linkToken=${linkToken}&accountId=${accountId}&idIsNew=${idIsNew}`
      try {
        const responseMovements = await bankAPI.getListMovements(
          accountId,
          linkToken,
          businessId,
          accountIdSql,
          idIsNew
        )
        console.log(responseMovements)
      } catch (error) {
        console.log(`Error al obtener movimientos para la cuenta ${accountId}:`, error)
        if (shouldShowBridge) banksStore.errorBankBridge('Error al traer movimientos')
      }
    }

    const getData = useBanks.getState().getData
    if (getData) {
      try {
        await getData()
      } catch (e) {
        console.debug('No fue posible refrescar movimientos antes de finalizar el bridge.', e)
      }
    }

    // Finalización del bridge
    if (shouldShowBridge) {
      banksStore.updateBankBridge({ phase: total, progress: 1 })
      banksStore.finishBankBridge()
      try {
        localStorage.setItem(flagKey, '1')
      } catch (e) {
        // ✅ Evita no-empty: logueamos en debug para entornos sin localStorage
        console.debug('No se pudo persistir bank_bridge_done en localStorage.', e)
      }
    }

    // Destruir el widget después de completar el proceso
    if (widgetInstance) {
      widgetInstance.destroy()
      widgetInstance = null
    }
  } catch (error) {
    useBanks.getState().errorBankBridge('Error iniciando la conexión')
    console.log('Error al inicializar Fintoc:', error)
  }
}

export const main = async (widgetToken, businessId) => {
  const options = {
    publicKey: 'pk_live_aL4pwxPybnC2h2EDavExhmS3N5aHXuqD',
    widgetToken,
    product: 'accounts',
    country: 'CL',
    onSuccess: async linkIntent => {
      const exchangeToken = linkIntent.exchangeToken
      console.log(exchangeToken)
      await sendExchangeTokenToBackend(exchangeToken, businessId)

      if (widgetInstance) {
        widgetInstance.destroy()
        widgetInstance = null
      }
    },
    onExit: () => {
      console.log('User has exited the widget.')
      if (widgetInstance) {
        widgetInstance.destroy()
        widgetInstance = null
      }
    }
  }
  try {
    // Reuse the existing promise if it exists, or start a new one
    if (!fintocPromise) {
      fintocPromise = getFintoc()
    }
    const Fintoc = await fintocPromise

    // If there's an existing widget instance, destroy it before creating a new one
    if (widgetInstance) {
      console.log('Destroying previous widget instance...')
      widgetInstance.destroy()
      widgetInstance = null
    }

    const widget = Fintoc.create(options)
    widgetInstance = widget

    // Adding a small delay (100ms) to allow the library and iframe communication to stabilize.
    // This often resolves the 'postMessage' origin mismatch error on the first attempt.
    setTimeout(() => {
      if (widgetInstance === widget) {
        widget.open()
      }
    }, 100)
  } catch (error) {
    console.error('Error al inicializar Fintoc:', error)
    // Reset the promise in case of error so it can be retried
    fintocPromise = null
  }
}

export const getWidgetToken = async businessId => {
  const payload = { product: 'movements', country: 'cl', holder_type: 'business' }
  try {
    const response = await bankAPI.getWidgetToken(payload)
    console.log(response)
    const widgetToken = response.data.widget_token
    main(widgetToken, businessId)
  } catch (error) {
    console.log(error)
  }
}